import "./src/styles/global.css";

const GA4_MEASUREMENT_ID = "G-WV5YNBCBJH";

export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag === "function") {
    window.gtag("config", GA4_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }
};
